module.exports = {

    /* Handle the data and return the error and success message message */
    handleFormStatus(status) {
        var data = (
            status &&
            status.data &&
            status.data.error &&
            status.data.error.data &&
            status.data.error.data.arguments
        ) || "success";
        var status_data = data === "success" ? "success" : (data.toString());
        return status_data;
    },

    getValueForDropdown(data, fnd) {
        let dt = data.filter(res => res.value === fnd.value)
        return dt?.[0]?.value
    },

    handleDatePost(date) {
        var postdate = date.split('-')
        var arranged_date = `${postdate[2]}-${postdate[1]}-${postdate[0]}`
        return arranged_date
    },

    handleDateTimePost(dt) {
        let date = dt.getFullYear() + '-' + ("0" + (dt.getMonth() + 1)).slice(-2) + '-' + ("0" + dt.getDate()).slice(-2);
        let time = ("0" + dt.getHours()).slice(-2) + ":" + ("0" + dt.getMinutes()).slice(-2) + ":" + ("0" + dt.getSeconds()).slice(-2);
        return date + 'T' + time
    },

    handleDatePicker(dt) {
        let date = dt.getFullYear() + '-' + ("0" + (dt.getMonth() + 1)).slice(-2) + '-' + ("0" + dt.getDate()).slice(-2);
        return date
    },

    handleGetDate(dt) {
        var date = dt.split(" ");
        var s_date = date?.[0].split("-");
        var r_date = new Date(`${s_date[2]}-${s_date[1]}-${s_date[0]}`);
        return r_date;
    },

    getAPIIds(data) {
        let rdata = [];
        // eslint-disable-next-line
        let t = data?.forEach(res => rdata.push(res.id))
        return rdata
    },

    getBase64(file) {
        return new Promise(resolve => {
            let baseURL = "";
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                baseURL = reader.result;
                resolve(baseURL);
            };
        });
    }

}